import { render } from "./contactCoache.vue?vue&type=template&id=04aa69a8&scoped=true"
import script from "./contactCoache.vue?vue&type=script&lang=js"
export * from "./contactCoache.vue?vue&type=script&lang=js"

import "./contactCoache.vue?vue&type=style&index=0&id=04aa69a8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04aa69a8"]])

export default __exports__